<template>
  <div
    class="flex flex-column h-100 w-100 pos-relative o-hidden"
    id="app-wrapper"
    :class="{
      [(route.name ? route.name.replace(/\s+/g, '_') : route.path.replace(/\W+/g, '_')).toLowerCase()]: true,
      'pd-t-big': MOBILE_APP === 'ios',
      // В elevated-режиме фон задаёт .layout-elevated (бекдроп), утилиты bg-* его бы перебили.
      'bg-base': headerTheme === 'light' && !isPageElevated,
      'bg-inverse': headerTheme === 'dark' && !isPageElevated,
      'layout-elevated': isPageElevated,
      // Хедер вынут из потока (overlay/fixed) — контент под ним, и всё, что позиционируется
      // абсолютно (мобильный сайдбар), должно само отступать на высоту хедера. Где хедер
      // в потоке (static), такой отступ даёт разрыв — отсюда крючок для темы проекта.
      'header-out-of-flow': route.meta.header_mode === 'overlay' || route.meta.header_mode === 'fixed',
    }"
  >
    <transition name="moveFromTop" appear>
      <Loader class="pos-fixed z-index-10" v-if="!page || store.core.state.loading" :centered="true" />
    </transition>

    <transition name="moveFromTop" mode="out-in">
      <section class="w-100 h-100" v-if="FirstUse && route.meta.walkthrough">
        <component class="tab" :is="route.meta.walkthrough" name="Walkthrough" @updateFirstUse="updateFirstUse" :slides="[1, 2, 3]"> </component>
      </section>
    </transition>

    <transition name="moveFromTop" mode="out-in">
      <Status class="z-index-10" v-if="store.core.state.error.show" :data="store.core.state.error" @close="store.core.state.error.show = false" />
    </transition>

    <transition name="moveFromTop" mode="out-in">
      <Snack
        class="z-index-10"
        v-if="store.core.state.snack.show"
        :type="store.core.state.snack.type"
        :message="store.core.state.snack.message"
        :show="store.core.state.snack.show"
        @close="store.core.state.snack.show = false"
      />
    </transition>


    <component
      v-if="!MOBILE_APP && route.meta.header"
      ref="header"
      :is="route.meta.header"
      :theme="headerTheme"
      :logotype="route.meta.logotype"
      :location="route.meta.location"
      :headerClass="computedHeaderClass"
      :showCart="route.meta.header_show_cart ?? true"
      :showProfile="route.meta.header_show_profile ?? true"
      :showNotifications="route.meta.header_show_notifications ?? true"
    >
      <component
        v-if="route.meta?.header_navigation"
        :is="route.meta.header_navigation"
        :horizontal="true"
        :navigationItems="route.meta.header_navigation_items"
        v-model:stateSidebar="store.core.state.isOpenSidebar"
        :theme="headerTheme"
      />
      <template #right>
        <component v-if="route.meta?.header_right_component" :is="route.meta.header_right_component" :theme="headerTheme" />
      </template>
    </component>


    <transition name="moveFromTop" mode="out-in" appear>
      <component
        v-if="MOBILE_APP && !route.meta.hideNavigationBar"
        :is="route.meta.navigationbar"
        :logotype="route.meta.logotype"
        :navigationItems="route.meta.sidebar_navigation_items"
        :stateSidebar="store.core.state.isOpenSidebar"
      />
    </transition>

    <Popup class="bg-base pd-semi w-m-33r radius-medium" @close-popup="closeLocationPopup" :isPopupOpen="store.core.state.isOpenLocationPopup">
      <LocationSelection />
    </Popup>

    <!-- class="flex flex-nowrap ease-in-out o-hidden pos-relative" -->
    <section
      class="flex flex-nowrap h-100 pos-relative o-hidden ease-in-out"
      id="screen"
      ref="screen"
      :class="{
        '': MOBILE_APP === 'ios',
      }"
    >
      <ShopCart
        :class="{
          'mobile:pd-t-extra': MOBILE_APP === 'ios',
        }"
      />
      <component
        v-if="route.meta?.sidebar"
        :is="route.meta.sidebar"
        :stateSidebar="store.core.state.isOpenSidebar"
        :widthHidden="route.meta?.sidebar_width_hidden"
        :width="route.meta?.sidebar_width"
        :theme="headerTheme"
        @closeSidebar="() => (store.core.state.isOpenSidebar = false)"
      >
        <!-- Header slot -->
        <!-- В elevated-лейауте глобальный хедер на десктопе скрыт, поэтому бренд
             живёт наверху сайдбара. Логотип тот же, что у хедера (route.meta.logotype),
             отдельного компонента под это не заводим. -->
        <template #header>
          <!-- Бренд-строка: логотип и кнопка сворачивания сайдбара справа. Геометрия
               свёрнутого состояния — та же, что у пунктов Navigation: контейнер pd-micro,
               кликабельный квадрат w-max-semi + aspect-1x1, то есть ровно ширина рельсы
               (w-3r). Отдельного места под кнопку в рельсе нет, поэтому по наведению
               квадрат знака подменяется кнопкой разворачивания (group-hover). -->
          <div
            v-if="isPageElevated && route.meta?.logotype"
            class="group ease-quint-out pos-relative flex-v-center flex-nowrap flex gap-thin mn-b-small"
            :class="store.core.state.isOpenSidebar ? 'pd-small pd-b-zero' : 'pd-micro'"
          >
            <!-- crop: логотип один и тот же в обоих состояниях, знак не меняет размер.
                 В рельсе ссылка — квадрат 2.5rem с o-hidden, wordmark просто обрезан;
                 при раскрытии он выезжает, а знак стоит на месте. -->
            <router-link
              :to="route.meta.context === 'backoffice' ? '/backoffice' : '/'"
              class="ease-quint-out d-block o-hidden mn-r-auto"
              :class="{ 'w-100 w-max-semi aspect-1x1 flex-center flex group-hover:opacity-0': !store.core.state.isOpenSidebar }"
            >
              <component :is="route.meta.logotype" :theme="headerTheme" :crop="true" />
            </router-link>

            <!-- Кнопки нет, пока сайдбар меняет ширину: с переходом или без, она едет
                 вместе с контейнером и наползает на логотип. Появляется, когда движение
                 закончилось.
                 Постоянной подложки нет — только подсветка --light по ховеру.
                 button--card здесь не годится: это --surface-raised, он на бекдропе
                 elevated-лейаута почти сливается с фоном. -->
            <button
              v-show="!isSidebarAnimating"
              type="button"
              class="radius-small hover:bg-card pd-zero flex-center flex flex-child-none cursor-pointer"
              :class="store.core.state.isOpenSidebar
                ? 'sidebar-toggle w-2r h-2r'
                : 'pos-absolute pos-t-micro pos-r-micro pos-b-micro pos-l-micro opacity-0 group-hover:opacity-100'"
              :aria-label="store.core.state.isOpenSidebar ? 'collapse sidebar' : 'expand sidebar'"
              @click="toggleSidebarWidth"
            >
              <IconSidebar class="i-medium" fill="rgb(var(--text-primary))" />
            </button>
          </div>
          <component v-else-if="route.meta?.sidebar_header_component" :is="route.meta.sidebar_header_component" :theme="headerTheme" :stateSidebar="store.core.state.isOpenSidebar" />
        </template>

        <!-- Navigation (default slot) -->
        <!-- sidebarNavInstant — имя без CSS-правил: Vue не находит анимации и меняет меню
             сразу. :css="false" здесь нельзя — с mode="out-in" Vue роняет вставку нового узла. -->
        <transition :name="animateSidebarNav ? 'moveFromTop' : 'sidebarNavInstant'" mode="out-in">
          <component
            v-if="sidebarNav.component"
            :is="sidebarNav.component"
            :key="sidebarNav.items"
            :navigationItems="sidebarNav.items"
            v-model:stateSidebar="store.core.state.isOpenSidebar"
            :theme="headerTheme"
          />
        </transition>

        <!-- Footer slot -->
        <template #footer>
          <component v-if="route.meta?.sidebar_footer_component" :is="route.meta.sidebar_footer_component" :theme="headerTheme" :stateSidebar="store.core.state.isOpenSidebar" />
        </template>

        <!-- Bottom slot: проект занимает его своим компонентом через
             route.meta.sidebar_bottom_component; без него Sidebar рендерит
             свой дефолтный переключатель темы (slot fallback). -->
        <template v-if="route.meta?.sidebar_bottom_component" #bottom>
          <component :is="route.meta.sidebar_bottom_component" :theme="headerTheme" :stateSidebar="store.core.state.isOpenSidebar" />
        </template>
      </component>

      <div class="rows-[minmax(0,1fr)] z-index-1 pos-relative w-100 h-100">
        <div class="o-y-scroll o-x-hidden h-100" id="scrollview" ref="scrollview" @scroll="handleScroll" style="container-type: size">
          <!-- Панель лежит ВНУТРИ скроллера, а не оборачивает его: её верхний отступ и
               скругление должны уезжать вверх вместе с контентом. Отступ виден только в
               нулевой позиции скролла, дальше панель идёт вплотную к верхнему краю.
               В elevated-режиме ширину/высоту задают маржины панели, поэтому без w-100
               (иначе width:100% + margin-right вылезает вбок) и без h-min-100 (утилита
               unlayered, перебила бы min-height с вычетом верхнего маржина). -->
          <div class="pos-relative" :class="isPageElevated ? 'page-panel' : 'h-min-100 w-100'">
            <!-- <section v-if="!route.meta?.breadcrumbs?.hide" class="pd-thin pd-b-zero">
				<Breadcrumbs
					v-if="!MOBILE_APP"
					class="bg-card pd-small radius-small"
				/>
			</section> -->

            <Suspense @resolve="onSuspenseResolved">
              <router-view
                class="h-min-100 pos-relative w-100"
                id="view"
                v-slot="{ Component, route }"
                :class="{
                  'scroll-hide': MOBILE_APP,
                }"
              >
                <transition @before-enter="scrollTop" name="scaleTransition" mode="out-in" appear>
                  <div class="w-100 h-min-100" :key="componentKey">
                    <component class="w-100 h-min-100" ref="page" :is="Component" @page-loading="handlePageLoading" @page-loaded="handlePageLoaded" />
                    <component
                      v-if="!MOBILE_APP && route.meta.footer && !route.meta.hideFooter"
                      ref="footer"
                      :is="route.meta.footer"
                      :theme="route.meta.footer_theme || 'light'"
                      :logotype="route.meta.logotype"
                      :location="route.meta.location"
                    />
                  </div>
                </transition>
              </router-view>
            </Suspense>
          </div>

          <component class="z-index-2" id="player-wrapper" v-if="route.meta.player" :is="route.meta.player" />
        </div>
      </div>
    </section>

    <router-view v-slot="{ Component, route }" name="defaultBottom">
      <component :is="Component" />
    </router-view>

    <component class="z-index-2" v-if="MOBILE_APP && route.meta.title_hide" :is="route.meta.bottombar" />
  </div>
</template>

<script setup>
import { computed, ref, shallowRef, watch, onMounted, onUnmounted } from 'vue';
// Router
import { useRoute } from 'vue-router';
// Store
import { useStore } from '@martyrs/src/modules/core/views/store/core.store.js';
import { useGlobalMixins } from '@martyrs/src/modules/core/views/mixins/mixins.js';
// Partials
import Status from '@martyrs/src/design-system/components/Status/Status.vue';
import Snack from '@martyrs/src/design-system/components/Status/Snack.vue';
import Popup from '@martyrs/src/design-system/components/Popup/Popup.vue';
import Breadcrumbs from '@martyrs/src/design-system/components/Breadcrumbs/Breadcrumbs.vue';
import Loader from '@martyrs/src/design-system/components/Loader/Loader.vue';

import IconSidebar from '@martyrs/src/modules/icons/navigation/IconSidebar.vue';

import NavigationBar from '@martyrs/src/modules/core/views/components/partials/NavigationBar.vue';
import LocationSelection from '@martyrs/src/modules/core/views/components/partials/LocationSelection.vue';

import ShopCart from '@martyrs/src/modules/orders/components/partials/ShopCart.vue';
// PROPS
const props = defineProps({
  env: {
    type: Object,
    required: true,
  },
  app: {
    type: Object,
    required: true,
  },
  modules: {
    type: Object,
    required: true,
  },
});

const store = useStore();

/////////////////////////////
// LOADING
/////////////////////////////
// State
let show = ref(false);
// Preloader
const page = ref(null);
const scrollview = ref(null);

// isPageLoading убран - используем core.state.loading

// Обработчики событий загрузки
function handlePageLoading() {
  store.core.state.loading = true;
}

function handlePageLoaded() {
  store.core.state.loading = false;
}

// Обработка события разрешения Suspense (когда async setup компонента завершается)
function onSuspenseResolved() {
  // Если страница не отправляет событие page-loaded, этот обработчик
  // может служить запасным вариантом для отключения лоадера
  // Можно оставить закомментированным, если все страницы будут явно вызывать handlePageLoaded
  store.core.state.loading = false;
}
/////////////////////////////
// CREATED
/////////////////////////////
const route = useRoute();
// const router = useRouter()

// Многоуровневый лейаут (route.meta.page_elevated): сайдбар лежит на бекдропе,
// страница — приподнятая панель .page-panel (скругление + тень, стили в blocks.scss).
const isPageElevated = computed(() => route.meta?.page_elevated === true);

// Инициализация sidebar для SSR + первая загрузка
if (route.meta?.sidebarOpenOnEnter === true && !store.core.state.isSidebarClosedByUser) {
  store.core.state.isOpenSidebar = true;
}

// Сайдбар — один инстанс на все роуты, меняется только его ширина (класс ease-quint-out,
// то есть transition: all .33s). Навигация внутри него принадлежит роуту, и если менять её
// в момент коммита роута, то во время движения контейнера внутри видно меню чужого раздела:
// при раскрытии — меню лендинга в открывающемся сайдбаре дашборда, при схлопывании — меню
// лендинга в ещё не схлопнувшемся сайдбаре. Поэтому рендерим не route.meta напрямую, а
// снимок, который подменяется с оглядкой на то, движется ли сам сайдбар.
const SIDEBAR_WIDTH_ANIMATION_MS = 330;

// Сайдбар занимает место, когда раскрыт или свёрнут в рельсу с иконками. На лендингах он
// схлопнут в ноль (sidebar_width_hidden: 'w-zero') и существует только ради мобильного бургера.
const isSidebarVisible = computed(() => {
  const widthHidden = route.meta?.sidebar_width_hidden;
  return store.core.state.isOpenSidebar || !(widthHidden === 'w-zero' || widthHidden === 'w-0');
});

// Кнопка сворачивания скрыта на время движения ширины: она стоит в шапке сайдбара
// и во время анимации ползёт вместе с ней, наезжая на логотип. Тот же таймер длины,
// что и у подмены навигации.
const isSidebarAnimating = ref(false);
let sidebarWidthTimer = null;

function toggleSidebarWidth() {
  store.core.state.isOpenSidebar = !store.core.state.isOpenSidebar;
  // Запоминаем ручное решение: свернул — смена роутов сайдбар не раскрывает,
  // раскрыл — автораскрытие снова разрешено.
  store.core.state.isSidebarClosedByUser = !store.core.state.isOpenSidebar;
  isSidebarAnimating.value = true;
  clearTimeout(sidebarWidthTimer);
  sidebarWidthTimer = setTimeout(() => {
    isSidebarAnimating.value = false;
  }, SIDEBAR_WIDTH_ANIMATION_MS);
}

const readSidebarNav = () => ({
  component: route.meta?.sidebar_navigation || null,
  items: route.meta?.sidebar_navigation_items || null,
});

const sidebarNav = shallowRef(readSidebarNav());
// Анимируем смену меню только когда сам сайдбар стоит на месте (дашборд ↔ бекофис). Если
// контейнер в этот момент раскрывается или схлопывается, подмена мгновенная.
const animateSidebarNav = ref(true);

let sidebarNavTimer = null;
let wasSidebarVisible = isSidebarVisible.value;

watch(
  () => route.fullPath,
  () => {
    const next = readSidebarNav();
    const isVisible = isSidebarVisible.value;

    if (next.component === sidebarNav.value.component && next.items === sidebarNav.value.items) {
      wasSidebarVisible = isVisible;
      return;
    }

    clearTimeout(sidebarNavTimer);

    if (isVisible && wasSidebarVisible) {
      // Контейнер не двигается — меняется только содержимое, с анимацией.
      animateSidebarNav.value = true;
      sidebarNav.value = next;
    } else if (isVisible) {
      // Сайдбар раскрывается: новое меню нужно сразу, без проигрывания ухода старого.
      animateSidebarNav.value = false;
      sidebarNav.value = next;
    } else {
      // Сайдбар схлопывается: держим уходящее меню, пока идёт анимация ширины.
      animateSidebarNav.value = false;
      sidebarNavTimer = setTimeout(() => {
        sidebarNav.value = readSidebarNav();
      }, SIDEBAR_WIDTH_ANIMATION_MS);
    }

    wasSidebarVisible = isVisible;
  }
);

onUnmounted(() => {
  clearTimeout(sidebarNavTimer);
  clearTimeout(sidebarWidthTimer);
});

// Ref Code
const referalCode = ref(route.query.referalCode);
/////////////////////////////
// Methods
/////////////////////////////
function closeLocationPopup() {
  store.core.state.isOpenLocationPopup = false;
}
function scrollTop() {
  if (scrollview.value) scrollview.value.scrollTop = 0;
}
// Scrolling header
const scrollOffset = ref(0);
const header = ref(null);

// Режим → классы позиционирования
const modeClasses = {
  static: 'pos-relative',
  sticky: 'pos-sticky pos-t-0',
  fixed: 'pos-fixed pos-t-0 w-100',
  overlay: 'pos-absolute pos-t-0 w-100'
};

// isScrolled
const isScrolled = computed(() =>
  scrollOffset.value > (route.meta.header_scroll_threshold ?? 50)
);

// headerTheme с учётом скролла
const headerTheme = computed(() => {
  if (isScrolled.value && route.meta.header_scroll_theme) {
    return route.meta.header_scroll_theme;
  }
  return route.meta.header_theme || 'light';
});

// headerModeClass (overlay → fixed после скролла)
const headerModeClass = computed(() => {
  const mode = route.meta.header_mode || 'static';
  if (mode === 'overlay' && isScrolled.value) {
    return 'pos-fixed pos-t-0 w-100';
  }
  return modeClasses[mode];
});

// headerAppearanceClass
const headerAppearanceClass = computed(() => {
  const config = isScrolled.value
    ? route.meta.header_scroll_class
    : route.meta.header_class;

  if (config && typeof config === 'object') {
    return config[headerTheme.value];
  }
  return config;
});

// Autohide
const isHidden = ref(false);
let lastScrollY = 0;

// computedHeaderClass для передачи в Header
const computedHeaderClass = computed(() => [
  headerModeClass.value,
  headerAppearanceClass.value,
  { 'header--hidden': isHidden.value }
]);

const handleScroll = (event) => {
  const scrollY = event.target.scrollTop;
  scrollOffset.value = scrollY;

  // Autohide логика
  if (route.meta.header_autohide) {
    if (scrollY > lastScrollY && scrollY > 200) {
      isHidden.value = true;
    } else if (scrollY < lastScrollY) {
      isHidden.value = false;
    }
    lastScrollY = scrollY;
  }
};
/////////////////////////////
// FIRST USE
/////////////////////////////
const FirstUse = ref(false);

import { Preferences } from '@capacitor/preferences';

async function getFirstUse() {
  const ret = await Preferences.get({ key: 'first-use' });
  FirstUse.value = ret.value ? JSON.parse(ret.value) : true;
}

const updateFirstUse = value => {
  FirstUse.value = value;
};

const { isPhone, isTablet } = useGlobalMixins();

onMounted(async () => {
  await getFirstUse();

  // Закрываем sidebar на mobile (CSS уже скрыл визуально)
  if ((isPhone() || isTablet()) && store.core.state.isOpenSidebar) {
    store.core.state.isOpenSidebar = false;
  }

  // Регистрация единого Service Worker (PWA + push notifications)
  if ('serviceWorker' in navigator && !window.__MOBILE_APP__) {
    window.addEventListener('load', () => {
      // updateViaCache:'none' — браузер всегда тянет /sw.js минуя HTTP-кеш,
      // иначе старый sw.js может жить до 24ч даже после редеплоя.
      navigator.serviceWorker
        .register('/sw.js', { updateViaCache: 'none' })
        .then(registration => {
          console.log('Unified SW registered: ', registration);
        })
        .catch(registrationError => {
          console.log('SW registration failed: ', registrationError);
        });
    });
  }

  if (!store.core.state.position && route.meta.location) {
    store.core.state.isOpenLocationPopup = true;
  } else {
    store.core.state.isOpenLocationPopup = false;
  }

  if (referalCode.value) {
    localStorage.setItem('referalCode', referalCode.value);
  }

  if (page.value) show.value = true;
});

const componentKey = computed(() => {
  // Собираем только значимые параметры (ID сущностей)
  const significantParams = ['_id', 'product', 'organization', 'categoryPath', 'country', 'state', 'city']
    .map(param => route.params[param])
    .filter(Boolean)
    .join('-');

  const identity = route.meta.layoutKey || route.name;
  return significantParams ? `${significantParams}-${identity}` : identity;
});
</script>

<style lang="scss">
/* Кнопка сворачивания сайдбара появляется после того, как ширина доехала (v-show),
   и проявляется, а не возникает рывком. Анимация, а не transition: переход по opacity
   на display:none→block не проигрывается, а анимация при показе перезапускается сама.
   Уход мгновенный — на клике кнопка должна исчезать сразу, не «догоняя» схлопывание.
   Класс вешается ТОЛЬКО в раскрытом состоянии: анимация с fill both держит opacity: 1
   и перебила бы подмену «знак ↔ кнопка» по ховеру в рельсе. */
.sidebar-toggle {
  animation: sidebarToggleIn 0.2s ease both;
}

@keyframes sidebarToggleIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active в версии 2.1.8+ */ {
  opacity: 0;
}

.fade-move,
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
}

/* 2. declare enter from and leave to state */
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translate(30px, 0);
}

/* 3. ensure leaving items are taken out of layout flow so that moving
        animations can be calculated correctly. */
.fade-leave-active {
  position: absolute;
}

.moveFromTop-enter-active,
.moveFromTop-leave-active {
  transition:
    all 0.3s ease,
    max-height 0.2s ease;
  overflow: hidden;
}

.moveFromTop-enter-from,
.moveFromTop-leave-to {
  transform: translateY(-1rem);
  opacity: 0;
  // max-height: 0;
}

.moveFromTop-enter-to,
.moveFromTop-leave-from {
  // max-height: 100vh;
}

.moveFromTopAbsolute-enter-active,
.moveFromTopAbsolute-leave-active {
  transform: translateY(0);
  opacity: 1;
  transition: all 0.5s ease;
}

.moveFromTopAbsolute-enter-from,
.moveFromTopAbsolute-leave-to {
  position: absolute;
  transform: translateY(-1rem);
  opacity: 0;
  transition: all 0.5s ease;
}

.ScaleOut-enter-active,
.ScaleOut-leave-active {
  opacity: 1;
  transform: scale(1);
  transition: all 0.3s ease;
}

.ScaleOut-enter-from,
.ScaleOut-leave-to {
  opacity: 0;
  transform: scale(0.9);
  transition: all 0.3s ease;
}

.slide-fade-enter-active {
  // min-height: 100vh;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-fade-leave-active {
  // min-height: 100vh;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  min-height: 0;
  transform: translateX(20px);
  opacity: 0;
  left: 0;
  top: 0;
}

.scaleTransition-5px-enter-active,
.scaleTransition-5px-leave-active {
  transform: translateY(0px);
  opacity: 1;
  z-index: 1;
  transition: all 0.2s ease;
}

.scaleTransition-5px-enter-from,
.scaleTransition-5px-leave-to {
  opacity: 0;
  z-index: 0;
  position: absolute;
  transform: translateY(-30px);
  transition: all 0.2s ease;
}

.scaleTransition-enter-from,
.scaleTransition-leave-to {
  opacity: 0;
  z-index: 0;
  position: absolute;
  width: inherit;
  height: inherit;
  display: block;
  transform: translateY(30px);
  transition: all 0.5s ease;
}

.scaleTransition-enter-active,
.scaleTransition-leave-active {
  transform: translateY(0px);
  opacity: 1;
  z-index: 1;
  transition: all 0.5s ease;
}

.scaleTransition-enter-from,
.scaleTransition-leave-to {
  opacity: 0;
  z-index: 0;
  position: absolute;
  width: inherit;
  height: inherit;
  display: block;
  transform: translateY(30px);
  transition: all 0.5s ease;
}

.scaleIn-enter-active,
.scaleIn-leave-active {
  // background: red;
  transition: all 0.5s ease;

  > section,
  div {
    transform-origin: 0 0;
    transform: translateZ(0px);
    transition: all 0.5s ease;
  }
}

.scaleIn-enter-from,
.scaleIn-leave-to {
  opacity: 0;
  transform: scale(0.95);

  > section,
  div {
    transform: translateZ(-30px);
    transition: all 0.5s ease;
  }
}
</style>
